export default __webpack_public_path__ + "static/media/Vector.cc4dfaae.svg";